import { GetterTree } from 'vuex';
import { PrivilegeIdLendingRecordState } from './types';
import { RootState } from '../../types';

const getDisplayable = state => (): boolean => state.displayable.isDisplayable;

export const getters: GetterTree<PrivilegeIdLendingRecordState, RootState> = {
    displayable: state => getDisplayable(state),
};
